<template>
  <span class="skel-block" :style="style" aria-hidden="true"></span>
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue'

export default defineComponent({
  name: 'SkeletonBlock',
  props: {
    width: { type: String, default: '100%' },
    height: { type: String, default: '14px' },
    radius: { type: String, default: 'var(--radius, 6px)' }
  },
  setup(props) {
    const style = computed(() => ({
      width: props.width,
      height: props.height,
      borderRadius: props.radius
    }))
    return { style }
  }
})
</script>

<style scoped lang="scss">
.skel-block {
  display: block;
  background: linear-gradient(
    100deg,
    rgba(31, 30, 26, 0.06) 30%,
    rgba(31, 30, 26, 0.12) 50%,
    rgba(31, 30, 26, 0.06) 70%
  );
  background-size: 200% 100%;
  animation: skeleton-shimmer 1.4s ease-in-out infinite;
}

:root[data-theme='dark'] .skel-block {
  background: linear-gradient(
    100deg,
    rgba(255, 255, 255, 0.06) 30%,
    rgba(255, 255, 255, 0.14) 50%,
    rgba(255, 255, 255, 0.06) 70%
  );
  background-size: 200% 100%;
}

@keyframes skeleton-shimmer {
  0% { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}

@media (prefers-reduced-motion: reduce) {
  .skel-block { animation: none; }
}
</style>
